module.exports = __webpack_public_path__ + "img/solana-logo.0139b563.svg";